import { jsxs as t, Fragment as h, jsx as e } from "react/jsx-runtime";
import { useState as v } from "react";
import { classes as o } from "../../utils/helpers.js";
import { NavList as b } from "../NavList/NavList.js";
import { LogoNavigation as N } from "../LogoNavigation/LogoNavigation.js";
import { ImageReplacementAnchor as k } from "../ImageReplacementAnchor/ImageReplacementAnchor.js";
import { Overlay as x } from "../Overlay/Overlay.js";
import '../../assets/DrawerNavigation.css';const n = {
  "drawer-navigation__nav-bar": "_drawer-navigation__nav-bar_5hknh_1",
  "with-logo": "_with-logo_5hknh_11",
  "drawer-navigation__menu-toggle": "_drawer-navigation__menu-toggle_5hknh_15",
  "drawer-navigation__hamburger": "_drawer-navigation__hamburger_5hknh_22",
  "drawer-navigation__primary-navigation": "_drawer-navigation__primary-navigation_5hknh_54",
  "drawer-navigation__separator": "_drawer-navigation__separator_5hknh_102",
  "visually-hidden": "_visually-hidden_5hknh_113"
};
function I({
  links: s = [],
  items: g = [],
  classname: c = "",
  logo: i = {},
  clipPathStart: p = "circle(0% at top right)",
  clipPathEnd: u = "circle(250% at top right)",
  overlayAppendEl: w = document.querySelector("#root")
}) {
  const [a, y] = v(!1), [d, l] = v(null), m = document.querySelector("body"), _ = () => {
    if (y(!a), l("closing"), a) {
      const r = document.querySelector("#overlay");
      r == null || r.setAttribute("data-state", "exiting"), setTimeout(() => {
        r == null || r.remove(), m.style.overflowY = "auto";
      }, 400);
    } else
      m.style.overflowY = "hidden";
  }, f = () => {
    a || l(null);
  };
  return document.addEventListener("scripps:overlay:closed", _), // Ideally the parent for this component will be a <nav> for accessibility reasons
  /* @__PURE__ */ t(h, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: o([
          n["drawer-navigation__nav-bar"],
          "drawer-navigation__nav-bar",
          i.image && n["with-logo"],
          `drawer-navigation__nav-bar--${a ? "expanded" : d ? "closing" : "closed"}`
        ]),
        children: [
          i.image && /* @__PURE__ */ e(
            k,
            {
              href: i.href,
              image: i.image,
              height: i.height,
              baselineAdjustment: i.baselineAdjustment
            }
          ),
          /* @__PURE__ */ t(
            "button",
            {
              className: o([
                n["drawer-navigation__menu-toggle"],
                "drawer-navigation__menu-toggle"
              ]),
              "aria-controls": "drawer-navigation__primary-navigation",
              "aria-expanded": a,
              onClick: _,
              children: [
                /* @__PURE__ */ e("span", { className: n["visually-hidden"], children: "Menu" }),
                /* @__PURE__ */ e(
                  "div",
                  {
                    className: o([
                      n["drawer-navigation__hamburger"],
                      "drawer-navigation__hamburger"
                    ]),
                    "aria-hidden": "true"
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: o([
          n["drawer-navigation__primary-navigation"],
          "drawer-navigation__primary-navigation"
        ]),
        id: "drawer-navigation__primary-navigation",
        "data-state": a ? "opened" : d || "closed",
        onAnimationEnd: f,
        style: {
          "--clip-path-start": p,
          "--clip-path-end": u
        },
        children: [
          s.length > 0 && /* @__PURE__ */ e(b, { links: s, classname: c, toggleHandler: _ }),
          g.length > 0 && /* @__PURE__ */ t(h, { children: [
            /* @__PURE__ */ e(
              "hr",
              {
                className: o([
                  n["drawer-navigation__separator"],
                  "drawer-navigation__separator"
                ])
              }
            ),
            /* @__PURE__ */ e(N, { items: g })
          ] })
        ]
      }
    ),
    a && /* @__PURE__ */ e(x, { appendToElement: w, state: d === null && !a ? "exiting" : "entering" })
  ] });
}
export {
  I as DrawerNavigation,
  I as default
};
